import { Button } from "reactstrap";

const AllReferencesPagination = ({
  query,
  setQuery,
  pagination,
  records,
  recordsLoading,
}) => {
  if (recordsLoading || !records || records?.length === 0) {
    return null;
  }

  return (
    <div className="d-flex">
      <div>
        <Button
          onClick={loadPage("PreviousPage")}
          size="sm"
          color="secondary"
          outline
          disabled={pagination && pagination.PreviousPage ? false : true}
          className="btn-icon-only mr-1"
        >
          <i className="mdi mdi-chevron-left"></i>
        </Button>
        <Button
          onClick={loadPage("NextPage")}
          size="sm"
          color="secondary"
          outline
          disabled={pagination && pagination.NextPage ? false : true}
          className="btn-icon-only mr-1"
        >
          <i className="mdi mdi-chevron-right"></i>
        </Button>
      </div>
    </div>
  );

  function loadPage(direction) {
    return () => {
      let newQuery = { ...query };

      newQuery.Pagination = {
        Count: 25,
        Page: pagination ? pagination[direction] : 1,
      };

      setQuery(newQuery);
    };
  }
};

export default AllReferencesPagination;
